import React from 'react';

import SummaryBar from '../summary-bar/summary-bar';
import VehicleImage from '../vehicle-image/vehicle-image';

import { Fitment } from '../../shared/types/fitment';

import styles from './vehicle-summary-bar.scss';

interface VehicleSummaryBarProps {
  fitment: Fitment;
  onClick: () => void;
}

function VehicleSummaryBar(props: VehicleSummaryBarProps) {
  const { fitment, onClick } = props;
  const { make, model, smallImageUrl, trim, year } = fitment || {};

  return (
    <SummaryBar className={styles['vehicle-banner']} onClick={onClick}>
      <VehicleImage
        alt={`vehicle image ${year} ${make} ${model}`}
        className={styles['vehicle-image']}
        height="31"
        smallImageUrl={smallImageUrl}
        width="70"
      />
      <div className={styles['vehicle-description']}>
        <strong>
          {year} {make}
        </strong>{' '}
        {model} {trim}
      </div>
    </SummaryBar>
  );
}

export default VehicleSummaryBar;
